import '@/bootstrap';
import Vue from 'vue';
import App from '@/App';
import VModal from 'vue-js-modal';
import LineClamp from 'vue-line-clamp';
import VueTheMask from 'vue-the-mask';
import VueCarousel from 'vue-carousel';
import StarRating from 'vue-star-rating';
import { BarLoader, BeatLoader } from '@saeris/vue-spinners';
import store from '@/store';
import router from '@/router';

Vue.use(VModal);
Vue.use(LineClamp);
Vue.use(VueCarousel);
Vue.use(VueTheMask);

Vue.component('star-rating', StarRating);
Vue.component('bar-loader', BarLoader);
Vue.component('beat-loader', BeatLoader);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
